import { create } from "zustand";

type TRecommendedFeedState = {
  feedId: string;
  feedGifsIds: string[];
}

type TRecommendedFeedActions = {
  setFeedId: (value: string) => void;
  setFeedGifsIds: (value: string[]) => void;
  reset: () => void;
}

const initialState: TRecommendedFeedState = {
  feedId: "",
  feedGifsIds: [],
};

export const useRecommendedFeedStore = create<TRecommendedFeedState & TRecommendedFeedActions>((set) => ({
  ...initialState,
  setFeedId: (value) => set(() => ({ feedId: value })),
  setFeedGifsIds: (value) => set(() => ({ feedGifsIds: value })),
  reset: () => set(initialState),
}));
